import { notification } from "antd";
import { PickPackRate, PickTierLine, VolumeTierLine, WeightTierLine } from "../interfeces";

export const INPUT_NEEDED = "input needed";
export const ALPHABET_ARRAY = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");

export const sanitazePickPackRate = (pickPackRate: PickPackRate) => ({
  weights: pickPackRate.weights.map((w: WeightTierLine) => ({
    ...w,
    to: w.to === "+" ? null : w.to,
    tiers: w.tiers.map((t: VolumeTierLine) => ({
      ...t,
      to: t.to === "+" ? null : t.to,
      picks: t.picks.map((p: PickTierLine) => ({
        ...p,
        to: p.to === "+" ? null : p.to,
      })),
    })),
  })),
  description: pickPackRate.description,
});

export const pickPackTableTierTemplate: PickTierLine[] = [
  {
    key: 1,
    from: 1,
    to: "+",
    price: 0,
    deletable: false,
  },
];

export const pickPackVolumeTierTemplate: VolumeTierLine[] = [
  {
    key: 1,
    from: 1,
    to: "+",
    picks: pickPackTableTierTemplate,
    deletable: false,
  },
];

export const pickPackWeightTierTemplate: WeightTierLine[] = [
  {
    key: 1,
    label: `Weight Tier ${ALPHABET_ARRAY[0]}`,
    from: 0,
    to: "+",
    deletable: false,
    tiers: pickPackVolumeTierTemplate,
  },
];

export const pickPackRateTemplate: PickPackRate = {
  weights: pickPackWeightTierTemplate,
  description: "Pick fee",
};

export const notifyError = (message: string) => {
  notification["error"]({ message });
};

export const notifyAlert = (message: string) => {
  notification["warning"]({ message });
};
